
import img1 from '../images/new/army.png'
import img2 from '../images/new/lebupay.png'
import img3 from '../images/new/realestate1.png'
import img4 from '../images/new/xm.png'
import img5 from '../images/new/msuruz.png'
import img6 from '../images/new/cipher.png'
import img7 from '../images/new/gorun1.png'
import img8 from '../images/new/lyxa1.jpg'
import img88 from '../images/new/carebox.webp'
import img99 from '../images/new/caredrop.webp'
import img111 from '../images/new/cobalt2.jpg'
import img112 from '../images/new/ambel.jpeg'
import img114 from '../images/new/spider-digital-red.png'
import img115 from '../images/new/papyrus.png'
import img116 from '../images/new/olympic.png'
import img117 from '../images/new/Clavis.png'
import img118 from '../images/new/study.png'
import img119 from '../images/new/study_gram.png'
import img122 from '../images/new/vumi.jpg'
import img133 from '../images/new/goti.png'
import img134 from '../images/new/client (1).png'
import img135 from '../images/new/client (2).png'
import img136 from '../images/new/client (3).png'
import img137 from '../images/new/client (4).png'
import img138 from '../images/new/client (5).png'
import img139 from '../images/new/client (6).png'
import img140 from '../images/new/client (7).png'
import img141 from '../images/new/client (8).png'
import img142 from '../images/new/client (9).png'
import img143 from '../images/new/mamungroup.png'
import img144 from '../images/new/msuruzre.png'


const dataItem = [

    {
        id: 1,
        img: img1,
        title: 'Monitoring Dashboard',
        des: 'Sasha Dashboard, Bangladesh Army Project',
        link: '#'
    },
    {
        id: 2,
        img: img122,
        title: 'Ministry of Land',
        des: 'Bangladesh Govt. Project',
        link: 'https://eporcha.gov.bd/'
    },
    {
        id: 3,
        img: img114,
        title: 'Spider Digital',
        des: ' Cyber Security, Defence & Intelligence Solutions provider',
        link: 'https://spiderdigital.io/'
    },
    {
        id: 4,
        img: img2,
        title: 'LebuPay',
        des: ' Fintech App For Remittance',
        link: 'http://3.111.147.160/'
    },

    {
        id: 5,
        img: img134,
        title: 'Partex Star Group',
        des: 'Partex Star Group',
        link: '#'
    },
    {
        id: 6,
        img: img116,
        title: 'Olympic Industries Ltd',
        des: 'Pioneer in FMCG in Bangladesh',
        link: 'http://olympicbd.com/'
    },
    {
        id: 7,
        img: img111,
        title: 'Cobalt Speech',
        des: 'Ai & Machine Learning Solutions Provider in the USA',
        link: 'https://www.cobaltspeech.com/'
    },
    {
        id: 8,
        img: img112,
        title: 'Ambel',
        des: 'Video Appointments Service Provider in Canada',
        link: 'https://ambel.ca/'
    },
    {
        id: 9,
        img: img135,
        title: 'Ashley Furniture',
        des: 'Ashley Furniture',
        link: '#'
    },
    {
        id: 9,
        img: img136,
        title: 'Adommo Dhaka',
        des: 'Adommo Dhaka',
        link: '#'
    },
    {
        id: 11,
        img: img137,
        title: 'Alter Sense',
        title: 'Alter Sense',
        link: '#'
    },
    {
        id: 12,
        img: img138,
        title: 'Partex Cables',
        des: 'Partex Cables',
        link: '#'
    },
    {
        id: 13,
        img: img139,
        title: 'FM Method',
        des: 'FM Method',
        link: '#'
    },
    {
        id: 14,
        img: img115,
        title: 'Papyrus Communications',
        des: 'Digital Marketing Solution',
        link: 'https://facebook.com/papyrusbd'
    },
    {
        id: 15,
        img: img117,
        title: 'Clavis Fintech',
        des: 'Fintech in Singapore',
        link: 'https://www.clavisfintech.com/'
    },


    {
        id: 16,
        img: img8,
        title: 'Lyxapp',
        des: ' Multi-Vendor Mobile App for Dubai & Lebanon',
        link: ''
    },
    {
        id: 17,
        img: img133,
        title: 'Goti Rentals',
        des: 'Bangladeshi Rental Ride-sharing  ',
        link: 'http://gotirentals.com/'
    },



    {
        id: 18,
        img: img6,
        title: 'Cipher Schools',
        des: 'Indian Ed-tech',
        link: 'https://www.cipherschools.com/'
    },
    {
        id: 19,
        img: img7,
        title: 'Gorun Mobile App',
        des: ' Delivery Mobile App',
        link: 'https://play.google.com/store/apps/details?id=com.gorun&hl=en'
    },
    {
        id: 20,
        img: img143,
        title: 'Mamun Group',
        des: 'Mamun Group',
        link: 'https://www.mamungroup.net/'
    },
    {
        id: 21,
        img: img119,
        title: 'Study Gram',
        des: 'Student Consultancy',
        link: 'https://www.studygrambd.com/'
    }, {
        id: 22,
        img: img4,
        title: 'Physics HQ',
        des: 'Internation School curriculums Ed-tech',
        link: 'https://physixhq.com/'
    },
    {
        id: 23,
        img: img88,
        title: 'CareBox',
        des: 'Ecommerce App',
        link: 'https://play.google.com/store/apps/details?id=care_box.carebox.com'
    },
    {
        id: 24,
        img: img144,
        title: 'MSuruzzaman Real Estate',
        des: 'Canda & North America based Real Estate',
        link: 'https://msuruzzamca.vercel.app/'
    },
    {
        id: 25,
        img: img3,
        title: 'Shams Al Majara',
        des: ' Real Estate in Dubai',
        link: 'https://shamsalmajara-re.com/'
    },
    {
        id: 26,
        img: img99,
        title: 'CareDrop',
        des: 'Health-care App',
        link: 'https://play.google.com/store/apps/details?id=com.caredrop'
    },




]

export default dataItem;